import React, { useState } from "react"
import BaseModal from "helper/component/basemodal";
import { Button } from "react-bootstrap";
import { setSsObject } from "helper";
import { localize } from "services/base";
import { toggleModal } from "signals/modal";

const Terms = () => {
    const [checked, setChecked] = useState(false)
    const handleClose = () => {
        setSsObject('hasAgreed', true)
        toggleModal({ name: 'terms', state: false });
    }

    const t = (key) => localize(key)
    return (
        <BaseModal tag={"terms"}>
            <p className="text-center fw-bold">{t('title_tnc')}</p>
            <div className="content">
                <iframe id="content_policy" name="content_policy" src={t(`iframe_content_tnc`)} title="description" width="100%" height="100%"></iframe>
            </div>
            <div className="footer">
                <span className="footer-agree" onClick={() => setChecked(!checked)}>
                    <input type="checkbox" name="agreed" checked={checked} onChange={() => setChecked(!checked)} />
                    <label htmlFor="agreed">{t('agree_tnc')}</label>
                </span>
                <Button className={`${checked ? '' : 'grayscale'} btn-accept btn-outline-light mt-3 px-3`} variant="danger" onClick={() => {
                    handleClose()
                }}>
                    {t('btn_agree_tnc')}
                </Button>
            </div>
        </BaseModal>
    )
}

export default Terms;
